import { Cookies } from 'react-cookie'
import { authCookieName } from './setAuthCookie'

export const getAuthCookie = (): string | null => {
  try {
    const cookieInstance = new Cookies()
    const cookie = cookieInstance.get(authCookieName) as string | undefined
    return cookie || null
  } catch (error) {
    console.error('Error accessing auth cookie:', error)
    return null
  }
}
